<div class="quick-news-group-manage">
  <nz-table
    #nzTable
    class="v4-layout-list layout-fixed"
    [nzShowPagination]="false"
    [nzFrontPagination]="false"
    [nzData]="groupList"
  >
    <thead>
      <tr>
        <th class="w-1/3">
          {{ "word.name" | translate }}
          <!-- Name -->
        </th>
        <th class="w-1/3">
          {{ "operate.field.quantity" | translate }}
          <!-- Number -->
        </th>
        <th class="w-1/3"></th>
      </tr>
    </thead>
    <tbody class="v4-layout-list-body">
      <tr *ngFor="let group of nzTable.data">
        <td>
          <div class="break-all">
            {{ group?.name }}
            <span class="scope" *ngIf="group.scope === 1">
              <!-- （全局） -->
              {{ "dialogue_setting.overall_use" | translate }}
            </span>
          </div>
        </td>
        <td>{{ group?.quick_comment_count }}</td>
        <td>
          <button
            nz-button
            class="mr-2 no-min-width"
            *ngIf="!isSubAccount || (isSubAccount && group.scope === 0)"
            (click)="edit(group)"
          >
            {{ "word.edit" | translate }}
            <!-- Edit -->
          </button>
          <button class="no-min-width" nz-button (click)="delete(group?.id)">
            {{ "word.delete" | translate }}
            <!-- Delete -->
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <div class="pt-[30px] text-right">
    <button nz-button nzType="primary" nzSize="large" (click)="addGroup()">
      {{ "property-house_group_html_添加组" | translate }}
      <!-- + Group -->
    </button>
  </div>
</div>
